import { Link } from "react-router-dom";
import { routes } from "@config/utilities/utils.constant";

function GetAQuoteButton({ text, ...props }) {
  return (
  //   <Link
  //     to={routes.CONTACTUS}
  //     className=" relative px-6 py-[14px] bg-[#FFC067] text-dark font-bold rounded shadow     text-base md:text-lg  transform transition-transform duration-300 hover:scale-110  inline-block c4"
  //     {...props}
  // aria-label="Internal link to Contact Us page"
  //   >
    <Link
      to={routes.CONTACTUS}
      className=" relative px-6 py-[14px] bg-[#FFC067] text-dark font-bold rounded shadow     text-base md:text-lg  transform transition-transform duration-300   inline-block c4 button-2"
      {...props}
  aria-label="Internal link to Contact Us page"
    >
      {text}
    </Link>
  );
}
export default GetAQuoteButton;
